import { IGamesContext, IFilterValues } from './gamesContext';

export enum GamesActionTypes {
	SET_GAMES = 'SET_GAMES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_DEVELOPER = 'SET_DEVELOPER',
	SET_CATEGORY = 'SET_CATEGORY',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	TOGGLE_UNASSIGNED_GAMES = 'TOGGLE_UNASSIGNED_GAMES',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetGames {
	type: GamesActionTypes.SET_GAMES;
	payload: {
		games: IGamesContext['games'];
		typeOfModalWindow: IGamesContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: GamesActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IGamesContext['searchString'];
	};
}

interface ISetDeveloper {
	type: GamesActionTypes.SET_DEVELOPER;
	payload: {
		selectedDeveloper: IGamesContext['selectedDeveloper'];
	};
}

interface ISetCategory {
	type: GamesActionTypes.SET_CATEGORY;
	payload: {
		selectedCategory: IGamesContext['selectedCategory'];
	};
}

interface IResetSelectedControls {
	type: GamesActionTypes.RESET_SELECTED_CONTROLS;
}

interface IToggleUnassignedGames {
	type: GamesActionTypes.TOGGLE_UNASSIGNED_GAMES;
}

interface ISetSortBy {
	type: GamesActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IGamesContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: GamesActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IGamesContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: GamesActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IGamesContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: GamesActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IGamesContext['IDForDeletion'];
		typeOfModalWindow: IGamesContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: GamesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IGamesContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: GamesActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TGamesAction =
	| ISetGames
	| IChangeSearchString
	| ISetDeveloper
	| ISetCategory
	| IResetSelectedControls
	| IToggleUnassignedGames
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
